import fpLogoTransparent from "@/assets/logo-transparent.svg?url";
import FpLogo from "@/components/layout/logo.svg";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import type { PropsWithChildren } from "react";
import { HomeTabs } from "./HomeTabs";
import backgroundImage1x from "./bg-1x.webp?url";
import backgroundImage2x from "./bg-2x.webp?url";

export function AuthLayout({ children }: PropsWithChildren) {
  return (
    <div className="min-h-full grid grid-cols-1 gap-y-8 lg:grid-cols-2 lg:grid-rows-[1fr_auto] max-lg:justify-items-center">
      <header className="lg:hidden bg-background/80 backdrop-blur-xl w-full sticky top-0 px-4 py-3 shadow-xl z-50 border-b">
        <FpLogo width={160} />
      </header>

      <div className="grid grid-cols-subgrid mx-4 gap-16 h-[max-content] row-start-2 row-span-2 col-span-full max-lg:place-items-center lg:col-start-1 lg:row-start-1 lg:row-span-1 lg:justify-items-center lg:self-center lg:gap-16 lg:mx-8 lg:mt-8">
        <Card className="col-start-1 row-start-1 max-lg:place-self-center max-lg:row-start-3 max-lg:col-span-full max-w-lg md:p-4 lg:p-8 w-full rounded-2xl backdrop-blur-md bg-background/15 border-white/10 shadow-2xl">
          <CardHeader className="space-y-2 md:space-y-5">
            <div className="flex justify-center">
              <div className="w-20 aspect-square">
                <img
                  src={fpLogoTransparent}
                  alt="Fiberplane Logo"
                  className="w-full h-full"
                />
              </div>
            </div>

            <CardTitle className="text-2xl md:text-3xl font-bold text-center text-foreground">
              Welcome to Fiberplane
            </CardTitle>

            <CardDescription className="text-center text-lg text-foreground/90">
              Sign in to create MCP servers and Hono APIs by chatting with AI.
            </CardDescription>
          </CardHeader>

          <CardContent>{children}</CardContent>
        </Card>

        <HomeTabs />
      </div>

      <div
        className="overflow-hidden bg-cover bg-center h-full w-full row-start-3 row-span-2 col-start-1 col-span-full lg:row-start-1 lg:col-start-1 lg:col-span-1"
        style={{
          backgroundImage: `image-set(url(${backgroundImage1x}) 1x, url(${backgroundImage2x}) 2x)`,
        }}
        aria-hidden="true"
        role="presentation"
      />

      <footer className="grid row-start-4 col-start-1 lg:col-span-full lg:row-start-2 lg:justify-items-center">
        <nav className="bg-background/10 border border-white/20 backdrop-blur-lg px-3 py-1 rounded-md shadow-xl inline-flex gap-2 text-sm text-white/70 mb-2">
          <a
            href="https://docs.fiberplane.com/"
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Docs
          </a>
          &bull;
          <a
            href="https://blog.fiberplane.com/blog/"
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Blog
          </a>
          &bull;
          <p>&copy; {new Date().getFullYear()} Fiberplane</p>
          &bull;
          <a
            href="https://docs.fiberplane.com/privacy-policy/"
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </nav>
      </footer>
    </div>
  );
}
